import '@/App.css';
import {
    BrowserRouter,
    Routes,
    Route,
    useLocation,
} from 'react-router-dom';
import { ThemeProvider } from '@/components/ThemeProvider';
import { AuthProvider } from '@/contexts/AuthContext';
import { Header } from '@/components/Header';
import { ProtectedRoute } from '@/components/ProtectedRoute';
import Landing from '@/pages/Landing';
import StyleGuide from '@/pages/StyleGuide';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import AuthCallback from '@/pages/AuthCallback';
import Account from '@/pages/Account';
import Workouts from '@/pages/Workouts';
import WorkoutBuilder from '@/pages/WorkoutBuilder';
import ActiveSession from '@/pages/ActiveSession';
import SessionRecap from '@/pages/SessionRecap';
import History from '@/pages/History';
import Insights from '@/pages/Insights';

function AppRouter() {
    const location = useLocation();

    if (location.hash?.includes('session_id=')) {
        return <AuthCallback />;
    }

    return (
        <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/style-guide" element={<StyleGuide />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/auth/callback" element={<AuthCallback />} />
            <Route
                path="/account"
                element={
                    <ProtectedRoute>
                        <Account />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/workouts"
                element={
                    <ProtectedRoute>
                        <Workouts />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/workouts/new"
                element={
                    <ProtectedRoute>
                        <WorkoutBuilder />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/workouts/:id"
                element={
                    <ProtectedRoute>
                        <WorkoutBuilder />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/sessions/:id"
                element={
                    <ProtectedRoute>
                        <ActiveSession />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/sessions/:id/recap"
                element={
                    <ProtectedRoute>
                        <SessionRecap />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/sessions"
                element={
                    <ProtectedRoute>
                        <History />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/insights"
                element={
                    <ProtectedRoute>
                        <Insights />
                    </ProtectedRoute>
                }
            />
        </Routes>
    );
}

function App() {
    return (
        <ThemeProvider defaultTheme="dark">
            <BrowserRouter>
                <AuthProvider>
                    <div className="App min-h-screen bg-background text-foreground font-sans">
                        <Header />
                        <AppRouter />
                    </div>
                </AuthProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
}

export default App;
